import {get} from '../utils'
import {getActiveChannel, isPublicChannel, getActiveClient} from "../authentication/utils";
import localization from '../../../config/localization';

export default host => (entity, query, limit = 10) =>
  get(`${host}${isPublicChannel() ? "/public": ""}/clients/${getActiveClient()}/channels/${getActiveChannel()}/user/${entity}/globalSearch?q=${query}&limit=${limit}&cLang=${localization.getLanguage()}`)
    .then(response => response.json())
    .then(json => json.data)